import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useDispatch} from 'react-redux';
import {IAppliedRule} from '../incase-domain/appliedRules';
import {saveAppliedRules} from '../service/appliedRule';
import {updateSelectedPresentationAppliedRulesAction} from '../store/actions/presentation';

type SaveAppliedRulesArgs = {
    appliedRules: IAppliedRule<number | string>[];
    presentationId: string;
};

export function useSaveAppliedRulesMutation(): UseMutationResult<IAppliedRule[] | undefined, Error, SaveAppliedRulesArgs> {
    const dispatch = useDispatch();

    return useMutation({
        mutationFn: ({appliedRules, presentationId}: SaveAppliedRulesArgs) =>
            saveAppliedRules({appliedRules: appliedRules as IAppliedRule[], presentationId}),
        onSuccess: (updated) => {
            if (updated) {
                dispatch(updateSelectedPresentationAppliedRulesAction(updated));
            }
        },
    });
}
